import { EllipsedText, MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { IdName } from '../../../types/app';

function SubClientItem({
  data,
  index,
  style,
}: Readonly<
  ListChildComponentProps<{
    subClients: IdName[];
    type: 'selectable' | 'deselectable';
    onClick: (subClientId: string) => void;
    isLoaded: (index: number) => boolean;
  }>
>) {
  const subClient = data.subClients[index];

  return (
    <span style={style as CSSProperties}>
      <ListItem
        endEnhancer={() => (
          <Button
            size="mini"
            shape="round"
            kind="tertiary"
            onClick={() => data.onClick(subClient._id)}
          >
            <MaterialIcon
              name={data.type === 'selectable' ? 'add' : 'remove'}
              size="mini"
            />
          </Button>
        )}
      >
        <ListItemLabel>
          <EllipsedText inline>{subClient?.name || '-'}</EllipsedText>
        </ListItemLabel>
      </ListItem>
    </span>
  );
}

export default memo(SubClientItem);
